import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getMyGigFilters } from "../../API/API";

function* searchMyGigGetFiltersSaga(params) {
  try {
    const response = yield call(getMyGigFilters,params); // API Backend
    yield put({ type: types.MY_GIG_FILTERS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.MY_GIG_FILTERS_FAILURE, error });
  }
}



export function* watchMyGigFiltersSaga() {
  yield takeEvery(types.MY_GIG_FILTERS_REQUESTED, searchMyGigGetFiltersSaga);
}
